import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import { Button, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { t } from "i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import {
    loadDeductionSettings as onLoadDeductionSettings,
    addDeductionSetting as onAddDeductionSetting,
    updateDeductionSetting as onUpdateDeductionSetting,
} from "../../../../slice/payroll/thunks";
import { toast } from "react-toastify";

const AddOrEditDeductionSetting = ({openModal, deductionId, deductionSetting, handleToggle, AddOrEditCloseModal, clickActionCallback}) => {

    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const clickAddOrUpdateDeductionSetting = useCallback((values) => {
            if(!deductionSetting) {
                dispatch(onAddDeductionSetting({
                    deductionId: deductionId,
                    data: values
                }))
                .unwrap()
                .then((response) => {
                    toast.success(response.message);
                    AddOrEditCloseModal();
                    setIsSubmitting(false);
                    dispatch(onLoadDeductionSettings(deductionId));
                })
                .catch((error) => {
                    toast.error(error.message);
                })
            } else {
                dispatch(onUpdateDeductionSetting({
                    id: deductionSetting.id,
                    deductionId: deductionSetting.deductionId,
                    data: values
                }))
                .unwrap()
                .then((response) => {
                    toast.success(response.message);
                    AddOrEditCloseModal();
                    setIsSubmitting(false);
                    dispatch(onLoadDeductionSettings(deductionId));
                })
                .catch((error) => {
                    toast.error(error.message);
                })
            }

    },[dispatch, deductionSetting, deductionId, AddOrEditCloseModal]);

    console.log(deductionSetting);

    const addOrEditForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            salaryMin: deductionSetting?.salaryMin ?? "",
            salaryMax: deductionSetting?.salaryMax ?? "",
            rateOrAmount: deductionSetting?.rateOrAmount ?? null,
            rank: deductionSetting?.rank ?? null,
            percentage: deductionSetting?.percentage ?? false,
            amountToConsider: deductionSetting?.amountToConsider ?? null,
        },
        onSubmit: (values) => {
            clickAddOrUpdateDeductionSetting(values)
        },
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: false,
        validationSchema: Yup.object({
            salaryMin: Yup.string()
                 .matches(/^[1-9]\d*(\.\d+)?$/, "Invalid value for salary min"),
            salaryMax: Yup.string()
                .matches(/^[1-9]\d*(\.\d+)?$/, "Invalid value for salary max"),
            rank: Yup.string()
                 .matches(/^[1-9]([0-9]?)+$/, "Invalid value for rank"),
            rateOrAmount: Yup.string()
                 .matches(/^[1-9]\d*(\.\d+)?$/, "Invalid value for rate / amount")
                 .required("Rate / Amount is required"),
            percentage: Yup.boolean()
        }),
    });

    return (
        <Modal isOpen={openModal} toggle={handleToggle} centered >
            <Form
                className="tablelist-form"
                autoComplete="off"
                onSubmit={(e) => {
                e.preventDefault();
                addOrEditForm.handleSubmit();
                    return false;
                }}
            >
                <ModalHeader toggle={AddOrEditCloseModal}>
                    {deductionSetting ? "Edit deduction setting" : "Add deduction setting" }
                </ModalHeader>
                <ModalBody>
                        <Row>
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    Rank
                                    <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    name="rank"
                                    type="text"
                                    value={addOrEditForm.values.rank}
                                    onChange={addOrEditForm.handleChange}
                                    onBlur={addOrEditForm.handleBlur}
                                    invalid={addOrEditForm.touched.rank && !!addOrEditForm.errors.rank}
                                />
                                <FormFeedback>
                                    {addOrEditForm.errors.rank}
                                </FormFeedback>
                            </Col>
                         </Row>
                         <Row className="mt-3">
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    Salary Min
                                </Label>
                                <Input
                                    name="salaryMin"
                                    type="text"
                                    value={addOrEditForm.values.salaryMin}
                                    onChange={addOrEditForm.handleChange}
                                    onBlur={addOrEditForm.handleBlur}
                                    invalid={addOrEditForm.touched.salaryMin && !!addOrEditForm.errors.salaryMin}
                                />
                                <FormFeedback>
                                    {addOrEditForm.errors.salaryMin}
                                </FormFeedback>
                            </Col>
                         </Row>
                         <Row className="mt-3">
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    Salary Max
                                </Label>
                                <Input
                                    name="salaryMax"
                                    type="text"
                                    value={addOrEditForm.values.salaryMax}
                                    onChange={addOrEditForm.handleChange}
                                    onBlur={addOrEditForm.handleBlur}
                                    invalid={addOrEditForm.touched.salaryMax && !!addOrEditForm.errors.salaryMax}
                                />
                                <FormFeedback>
                                    {addOrEditForm.errors.salaryMax}
                                </FormFeedback>
                            </Col>
                         </Row>
                         <Row className="mt-3">
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    Rate / Amount to deduct
                                    <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    name="rateOrAmount"
                                    type="text"
                                    value={addOrEditForm.values.rateOrAmount}
                                    onChange={addOrEditForm.handleChange}
                                    onBlur={addOrEditForm.handleBlur}
                                    invalid={addOrEditForm.touched.rateOrAmount && !!addOrEditForm.errors.rateOrAmount}
                                />
                                <FormFeedback>
                                    {addOrEditForm.errors.rateOrAmount}
                                </FormFeedback>
                            </Col>
                         </Row>
                         <Row className="mt-3">
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    <Input
                                        className="me-2"
                                        name="percentage"
                                        type="checkbox"
                                        value={addOrEditForm.values.percentage}
                                        onChange={addOrEditForm.handleChange}
                                        checked={addOrEditForm.values.percentage}
                                    />
                                    Is Percentage
                                </Label>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={12} sm={12}>
                                <Label className="form-label">
                                    Amount to consider if necessary
                                </Label>
                                <Input
                                    name="amountToConsider"
                                    type="text"
                                    value={addOrEditForm.values.amountToConsider}
                                    onChange={addOrEditForm.handleChange}
                                    onBlur={addOrEditForm.handleBlur}
                                    invalid={addOrEditForm.touched.amountToConsider && !!addOrEditForm.errors.amountToConsider}
                                />
                                <FormFeedback>
                                    {addOrEditForm.errors.amountToConsider}
                                </FormFeedback>
                            </Col>
                         </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="success"
                    disabled={isSubmitting || !addOrEditForm.isValid}
                    onClick={clickActionCallback}>
                            {t("save")}
                    </Button>
                    <Button color="secondary" onClick={AddOrEditCloseModal}>
                        {t("cancel")}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
};


export default withRouter(withTranslation()(AddOrEditDeductionSetting))